<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 :color="iconColor"
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            class="required"
                            input-class="rounded-tag-small"
                            label="Data Entrega Inicial"
                            v-model="localDataInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            class="required"
                            input-class="rounded-tag-small"
                            label="Data Entrega Final"
                            v-model="localDataFinal"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-comprador
              required
              dense
              class="rounded-tag-small"
              v-model="localEmpresa"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              required
              dense
              label="Comprador"
              :roles="['ROLE_COMPRADOR']"
              class="rounded-tag-small"
              v-model="localResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-produto-multiple v-model="localProduto"
                                              class="rounded-tag-small"
                                              show-details
                                              dense
                                              base-path="/produtos/page"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-centro-custo-multiple
              class="rounded-tag-small"
              dense
              v-model="localCentroCusto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-projeto-multiple
              dense
              class="rounded-tag-small"
              v-model="localProjeto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-grupo-multiple
              dense
              class="rounded-tag-small"
              v-model="localGrupo"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {},
  data: () => ({
    menuOpened: false,
    localDataInicial: null,
    localDataFinal: null,
    localEmpresa: null,
    localCentroCusto: [],
    localProduto: [],
    localProjeto: [],
    localResponsavel: [],
    localGrupo: [],
  }),
  computed: {
    ...mapGetters('gestaoEntrega', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    empresa: {
      get() {
        return this.$store.getters['gestaoEntrega/empresa'];
      },
      set(empresa) {
        this.$store.dispatch('gestaoEntrega/empresa', empresa);
      },
    },
    centroCusto: {
      get() {
        return this.$store.getters['gestaoEntrega/centroCusto'];
      },
      set(centroCusto) {
        this.$store.dispatch('gestaoEntrega/centroCusto', centroCusto);
      },
    },
    produto: {
      get() {
        return this.$store.getters['gestaoEntrega/produto'];
      },
      set(produto) {
        this.$store.dispatch('gestaoEntrega/produto', produto);
      },
    },
    projeto: {
      get() {
        return this.$store.getters['gestaoEntrega/projeto'];
      },
      set(projeto) {
        this.$store.dispatch('gestaoEntrega/projeto', projeto);
      },
    },
    responsavel: {
      get() {
        return this.$store.getters['gestaoEntrega/responsavel'];
      },
      set(responsavel) {
        this.$store.dispatch('gestaoEntrega/responsavel', responsavel);
      },
    },
    dataFinal: {
      get() {
        return this.$store.getters['gestaoEntrega/dataFinal'];
      },
      set(dataFinal) {
        this.$store.dispatch('gestaoEntrega/dataFinal', dataFinal);
      },
    },
    dataInicial: {
      get() {
        return this.$store.getters['gestaoEntrega/dataInicial'];
      },
      set(dataInicial) {
        this.$store.dispatch('gestaoEntrega/dataInicial', dataInicial);
      },
    },
    grupo: {
      get() {
        return this.$store.getters['gestaoEntrega/grupo'];
      },
      set(grupo) {
        this.$store.dispatch('gestaoEntrega/grupo', grupo);
      },
    },
  },
  methods: {
    emitChange() {
      this.empresa = this.localEmpresa;
      this.centroCusto = this.localCentroCusto;
      this.produto = this.localProduto;
      this.projeto = this.localProjeto;
      this.responsavel = this.localResponsavel;
      this.dataFinal = this.localDataFinal;
      this.dataInicial = this.localDataInicial;
      this.grupo = this.localGrupo;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localEmpresa = null;
      this.localCentroCusto = null;
      this.localProduto = null;
      this.localProjeto = null;
      this.localResponsavel = null;
      this.localDataFinal = null;
      this.localDataInicial = null;
      this.localGrupo = null;
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localEmpresa = this.empresa || null;
    this.localCentroCusto = this.centroCusto || [];
    this.localProduto = this.produto || [];
    this.localProjeto = this.projeto || [];
    this.localResponsavel = this.responsavel || [];
    this.localDataFinal = this.dataFinal || null;
    this.localDataInicial = this.dataInicial || null;
    this.localGrupo = this.grupo || [];
  },
};
</script>
